document.addEventListener('DOMContentLoaded', () => {
  const allLinks = document.querySelectorAll('a.image-block');

  allLinks.forEach(link => {
    const href = link.getAttribute('href');
    if (href && href.includes('instagram.com')) {
      link.setAttribute('target', '_blank');
      // link.setAttribute('rel', 'noopener noreferrer');
    }
  });
});
